export const Actions = {
    setLastTimestamp(context, timestamp) {
        if (!(timestamp && timestamp > 0)) {
            timestamp = 0;
        }
        context.commit('updaterSetLastTimestamp', timestamp);
    },
}
